module.exports = __webpack_public_path__ + "static/img/2.1c5e6b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/2.png
// module id = Y1qH
// module chunks = 0